import { gql } from 'graphql-request'
import { ItemPastaFragment } from './item-pasta-fragment'

export const CONCEDER_ACESSO = gql`
  mutation ConcederAcessoMutation($novasPermissoes: ConcederAcessoInput!) {
    concederAcesso(novasPermissoes: $novasPermissoes) {
      ...ItemPastaFragment
    }
  }
  ${ItemPastaFragment}
`
